<template>
  <AppTable
    :table-data="tableData"
    :loading="loading"
    :lazy-loading="lazyLoading"
    class="widget-common"
    table-classes="insights-github-integration-cards-table"
    @sort="sort"
  >
    <template #empty>
      <div class="text-center">
        <img
          height="76"
          :src="no_data_tracked.src"
          :alt="no_data_tracked.alt"
        />
        <div class="text-16 bold mt-10">No data</div>
        <div class="hint mt-5">There was no data registered in the time period selected</div>
      </div>
    </template>
    <AppTableColumn
      v-slot="{ row }"
      header="PR"
      name="title"
      :sort-by="buildSortOptions('title')"
    >
      <div class="d-flex align-items-center gap-10">
        <i class="fa text-24 fa-github" />
        <a
          :href="row.url"
          target="_blank"
          @click="$emit('row:click', row)"
        >
          {{ row.title }}
        </a>
      </div>
    </AppTableColumn>
    <AppTableColumn
      v-slot="{ row }"
      header="Author"
      name="author"
      :sort-by="buildSortOptions('author')"
    >
      <div class="ellipsis">{{ row.author }}</div>
    </AppTableColumn>
    <AppTableColumn
      v-slot="{ row }"
      header="TTM"
      name="time_to_merge"
      :sort-by="buildSortOptions('time_to_merge')"
      header-classes="text-align-right"
      cell-classes="text-align-right"
    >
      {{ formatValue(row.time_to_merge) }}
    </AppTableColumn>
    <AppTableColumn
      v-slot="{ row }"
      header="Time to 1st review"
      name="time_to_first_review"
      :sort-by="buildSortOptions('time_to_first_review')"
      header-classes="text-align-right"
      cell-classes="text-align-right"
    >
      {{ formatValue(row.time_to_first_review) }}
    </AppTableColumn>
    <AppTableColumn
      v-slot="{ row }"
      header="Current status"
      name="status"
    >
      <div class="status-wrapper">
        <span
          v-for="status in row.statuses"
          :key="status"
          :class="`status status-${status}`"
        >
          {{ status }}
        </span>
      </div>
    </AppTableColumn>
  </AppTable>
</template>

<script>
import dayjs from 'dayjs';
import { INSIGHTS_ASSETS as INSIGHTS } from '~/app_constants';

export default {
  name: 'InsightsGitHubIntegrationCardsTable',
  components: {},
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    showMetrics: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    lazyLoading: {
      type: Boolean,
      default: false,
    },
    sortOptions: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      no_data_tracked: INSIGHTS.no_data_tracked,
    };
  },
  methods: {
    sort(options) {
      this.$emit('sort', options);
    },
    buildSortOptions(field) {
      return {
        field,
        direction: (this.sortOptions?.field === field && this.sortOptions?.direction) || null,
      };
    },
    formatValue(value) {
      const duration = dayjs.duration(value, 'seconds');
      const string = [
        duration.days() && `${Math.floor(duration.asDays())}d`,
        `${duration.asHours() > 0 && duration.asHours() < 1 ? 1 : duration.hours()}h`,
      ]
        .filter((x) => x)
        .join(' ');

      return string === '0h' ? '—' : string;
    },
  },
};
</script>
